import React, { memo } from 'react';
import { 
  MessageSquare, 
  Code, 
  Search, 
  Globe 
} from 'lucide-react';
import { SENDER_AGENT, AGENT_TYPES } from '../constants';

/**
 * Message header component showing agent type and icon
 */
const MessageHeader = memo(({ sender, isSubAgent, agentType }) => {
  if (sender === 'user' || sender === 'system') return null;
  
  const getAgentDisplay = () => {
    // If sender is generic "agent", use the agentType prop
    const effectiveSender = sender === SENDER_AGENT ? agentType : sender;
    
    if (effectiveSender === AGENT_TYPES.CODING || effectiveSender === AGENT_TYPES.CODER) {
      return { icon: Code, text: 'Coding Agent', colorClass: 'text-accent-purple dark:text-accent-purpleLight' };
    } else if (effectiveSender === AGENT_TYPES.INVESTIGATION) {
      return { icon: Search, text: 'Investigation Agent', colorClass: 'text-accent-purple dark:text-accent-purpleLight' };
    } else if (effectiveSender === AGENT_TYPES.BROWSER) {
      return { icon: Globe, text: 'Browser Agent', colorClass: 'text-accent-purple dark:text-accent-purpleLight' };
    } else {
      return { icon: MessageSquare, text: effectiveSender, colorClass: 'text-semantic-warning' };
    }
  };
  
  const { icon: Icon, text, colorClass } = getAgentDisplay();
  
  return (
    <div className="flex items-center mb-1 text-xs font-medium">
      <Icon size={14} className={`mr-1 ${colorClass}`} />
      <span className={colorClass}>
        {text}
        {isSubAgent && <span className="ml-1 opacity-75">(Sub-Agent)</span>}
      </span>
    </div>
  );
});

MessageHeader.displayName = 'MessageHeader';

export default MessageHeader;
